import { Alert, Badge, Button, Card, authConfig } from '@jmvilaca-corp/auth-ui'
import { pushSupport, useDisablePush, useEnablePush, usePushDevice, usePushSettings, useTestPush } from '../lib/push'

/**
 * Notifications push : un abonnement par appareil, que son porteur active ici.
 * Rien ne s'affiche tant que le serveur n'a pas de cle d'envoi.
 */
export default function NotificationsCard() {
  const settings = usePushSettings()
  const publicKey = settings.data?.publicKey
  const device = usePushDevice(publicKey)
  const enable = useEnablePush()
  const disable = useDisablePush()
  const test = useTestPush()

  if (typeof publicKey !== 'string') {
    return null
  }

  const { appName } = authConfig()
  const support = pushSupport()
  const active = device.data === true
  const failure = enable.error ?? disable.error ?? test.error ?? device.error

  return (
    <Card title="Notifications">
      <div className="mb-4 flex items-center gap-2 text-sm">
        <span className="text-neutral-600 dark:text-neutral-400">Etat :</span>
        {active ? <Badge tone="ok">Activees sur cet appareil</Badge> : <Badge tone="neutral">Desactivees sur cet appareil</Badge>}
      </div>

      <p className="mb-3 text-sm text-neutral-600 dark:text-neutral-400">
        Vous etes prevenu quand un calendrier est partage avec vous. Les notifications arrivent meme
        application fermee, et s'activent appareil par appareil.
      </p>

      {support === 'needs-install' && (
        <Alert tone="info">
          Sur iPhone et iPad, les notifications demandent d'ajouter {appName} a l'ecran d'accueil (bouton Partager, puis
          « Sur l'ecran d'accueil ») et de l'ouvrir depuis son icone.
        </Alert>
      )}
      {support === 'unsupported' && <Alert tone="info">Ce navigateur ne permet pas les notifications.</Alert>}

      {failure !== null && failure !== undefined && (
        <div className="mb-3">
          <Alert>{failure.message}</Alert>
        </div>
      )}
      {test.isSuccess && (
        <div className="mb-3">
          <Alert tone={test.data > 0 ? 'success' : 'info'}>
            {test.data > 0
              ? "Notification d'essai envoyee : elle arrive dans quelques secondes."
              : "Aucun appareil n'a pu etre prevenu. Desactivez puis reactivez les notifications sur cet appareil."}
          </Alert>
        </div>
      )}

      {support === 'supported' && (
        <div className="flex flex-wrap gap-2">
          {active ? (
            <>
              <Button type="button" size="sm" variant="outline" disabled={test.isPending} onClick={() => test.mutate()}>
                Envoyer une notification d'essai
              </Button>
              <Button
                type="button"
                size="sm"
                variant="danger"
                disabled={disable.isPending}
                onClick={() => {
                  test.reset()
                  disable.mutate()
                }}
              >
                Desactiver sur cet appareil
              </Button>
            </>
          ) : (
            <Button
              type="button"
              size="sm"
              disabled={enable.isPending || device.isPending}
              onClick={() => {
                disable.reset()
                enable.mutate(publicKey)
              }}
            >
              Activer sur cet appareil
            </Button>
          )}
        </div>
      )}
    </Card>
  )
}
